import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { MessageNotificationService } from 'message-notification-service-lib';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Identity } from 'storage-service-lib';
import { environment } from '../../../environments/environment';
import { ServiceProviderService } from '../../services/service.provider.service';

export interface VerifyLoginOtpResponse {
  jwtToken: string;
  namespace: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private http: HttpClient, private sps: ServiceProviderService, private messageNotification: MessageNotificationService) {}

  verifyLoginOtp(otp: string): Observable<VerifyLoginOtpResponse> {
    return this.http.get<VerifyLoginOtpResponse>(`${environment.kpHost}/adv2/config/auth/otp/verify?otp=${otp}`).pipe(
      catchError((err) => {
        console.error(err);
        this.messageNotification.error('Login code invalid or expired');
        return EMPTY;
      })
    );
  }

  signInWithLoginOtp(otpObject: VerifyLoginOtpResponse, loginSuccess: EventEmitter<Identity>): void {
    try {
      const decoded = jwtDecode<any>(otpObject.jwtToken);
      const valid = decoded.exp !== undefined && Date.now() < decoded.exp * 1000;
      if (!valid) {
        this.messageNotification.error('The supplied token is invalid or has expired.');
        return;
      }
      this.sps.getAuthService(otpObject.namespace).signInWithOtp(decoded, otpObject, loginSuccess);
    } catch (e) {
      console.error(e);
      this.messageNotification.error('The supplied token is not valid.');
    }
  }
}
